import { ChangeEvent } from "react";
import { Blob } from "buffer"

/** bring up a file browser, then load the selected file as text */
export function browseAndLoad(onLoad: (filename: string, contents: string) => void) {
  function onChange(e: Event) {
    const event = e as unknown as ChangeEvent<HTMLInputElement>;
    const files = event.target.files;
    if (files === null || files.length === 0) {
      return;
    }
    files[0].text().then(str => onLoad(files[0].name, str));
  }

  const el = document.createElement("input");
  el.type = "file";
  el.onchange = onChange;
  document.body.appendChild(el);
  el.click();
  setTimeout(function () {
    document.body.removeChild(el);
  }, 0);
}

/** bring up a file browser, then load the selected file as binary */
export function browseAndLoadBinary(onLoad: (filename: string, contents: Uint8Array) => void) {
  function onChange(e: Event) {
    const event = e as unknown as ChangeEvent<HTMLInputElement>;
    const files = event.target.files;
    if (files === null || files.length === 0) {
      return;
    }
    const blob = files[0] as unknown as Blob; // unclear why the compiler doesn't think it's a Blob
    blob.bytes().then(data => onLoad(files[0].name, data));
  }

  const el = document.createElement("input");
  el.type = "file";
  el.onchange = onChange;
  document.body.appendChild(el);
  el.click();
  setTimeout(function () {
    document.body.removeChild(el);
  }, 0);
}
